import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';

import { FeedComponent } from './feed.component';
import { FeedDetailComponent } from './feed-detail.component';
import { FeedPopupComponent } from './feed-dialog.component';
import { FeedDeletePopupComponent } from './feed-delete-dialog.component';

import { Principal } from '../../shared';

export const feedRoute: Routes = [
    {
        path: 'feed',
        component: FeedComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [UserRouteAccessService]
    }, {
        path: 'feed/:id',
        component: FeedDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const feedPopupRoute: Routes = [
    {
        path: 'feed-new',
        component: FeedPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'feed/:id/edit',
        component: FeedPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'feed/:id/delete',
        component: FeedDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed.route.ts